import { TrackingProvider } from '@/helpers/tracking/providers/tracking-provider';

type DatadomeWindow = Window &
	typeof globalThis & {
		ddjskey: string;
		ddoptions: any;
	};
export class DatadomeTag extends TrackingProvider {
	override required = true;
	dataProcessingService = null;

	constructor(private config: { doNotTrack: boolean }) {
		super();
	}

	initialize(): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			if (this.config.doNotTrack || typeof window === 'undefined' || import.meta.server) {
				return resolve();
			}

			try {
				(window as DatadomeWindow).ddjskey = '705CE572A13C868C0D28BFD3ABA2D3';
				// Add configuration here
				(window as DatadomeWindow).ddoptions = {};

				const f = document.getElementsByTagName('script')[0],
					j = document.createElement('script');
				j.async = true;
				j.src = 'https://js.datadome.co/tags.js';

				f && f.parentNode!.insertBefore(j, f);

				resolve();
			} catch {
				reject();
			}
		});
	}

	async trackEvent() {}
	async trackPage() {}

	refreshPermanentAudiences() {}
	refreshPermanentAudiencesSubgenres() {}
}
